import React from 'react';
import { Card, Form, Spin, Row, Col, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'dva';
import moment from 'moment-timezone';
import LeadDetailsCard from '../LeadDetailsCard/LeadDetailsCard';
import CustomizedForm from '../LeadDetailsFilter/LeadDetailsFilter';
import helpers from '../../../utils/helpers';
import styles from '../styles.less';
import ScoringCircle from '../../common/ScoringCircle';

class LeadDetails extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = this.props.match.params;
    this.projectId = urlParams.projectId;
    this.leadId = urlParams.leadId;
    this.companyVisitsLimit = 20;

    this.state = {
      allLeadMarks: [],
      companyVisits: [],
      hideLoadMoreButton: true,
      filters: {},
    };
  }

  componentDidMount() {
    this.getDetailsRequest();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.matomo.leadDetails && !prevProps.matomo.leadDetails)
      || ((prevProps.matomo.leadDetails && this.props.matomo.leadDetails)
        && (prevProps.matomo.leadDetails.id !== this.props.matomo.leadDetails.id))) {
      this.props.dispatch({
        type: 'header/update',
        payload: {
          variable: this.props.matomo.leadDetails.company_name,
        },
      });
    }
  }

  getDetailsRequest() {
    const leadId = this.leadId;
    const projectId = this.projectId;
    const payload = {
      projectId,
      leadId,
    };

    this.props.dispatch({
      type: 'leads/getDetails',
      payload,
    }).then((leadDetails) => {
      this.props.dispatch({
        type: 'matomo/updateStore',
        payload: { leadDetails },
      });
      this.fetchCompanyVisits();
      return this.props.dispatch({ type: 'leadLabels/loadList' });
    });
  }

  getModifiedVisits() {
    return this.state.companyVisits.map((visit) => {
      const tz = moment.tz(visit.first_action_timestamp, this.props.user.display_timezone);
      return {
        ...visit,
        date: moment(tz).format(this.props.user.display_datetime_format),
        amountOfPages: visit.page_views,
        durationOfVisit: helpers.getTimeFromDuration(visit.visit_duration, 'seconds'),
        campaign: <FormattedMessage id={`Common.${visit.ad_campaign ? 'Yes' : 'No'}`} />,
        position: visit.id,
        source: visit.referrer_type.label,
        score: visit.final_score,
      };
    });
  }

  fetchCompanyVisits() {
    const leadId = this.leadId;
    const projectId = this.projectId;
    const companyVisitsLimit = this.companyVisitsLimit;

    this.props.dispatch({
      type: 'matomo/getCompanyVisits',
      payload: {
        projectId,
        companyId: leadId,
        limit: companyVisitsLimit,
        skip: this.state.companyVisits.length,
        filter: this.filtersToQueryFilter(),
      },
    }).then((res) => {
      const companyNumberOfvisits = this.props.matomo.leadDetails ?
        this.props.matomo.leadDetails.number_of_visits :
        0;

      const visitsToShow = this.state.companyVisits.concat(res.data);
      this.setState({
        hideLoadMoreButton: res.data.length === 0 || companyNumberOfvisits === visitsToShow.length,
        companyVisits: visitsToShow,
      });
    });
  }

  handleFormChange = (changedFields) => {
    const filters = this.state.filters;
    this.setState({
      filters: { ...filters, ...changedFields },
      companyVisits: [],
    }, () => {
      this.fetchCompanyVisits();
    });
  };

  filtersToQueryFilter = () => {
    const {
      dateRange,
      score,
      campaign,
    } = this.state.filters;

    const filterParams = {};

    if (campaign && campaign.trim().length > 0) {
      filterParams.referrer_type = 'campaign';
      filterParams.referrer_keyword = `*${campaign.trim()}*`;
    }

    // score filter present and not equal to show all
    if (score && score !== 'ALL') {
      if (score === '[null]') {
        filterParams.finalScore = score;
      } else {
        filterParams[`finalScore>=${score}`] = null;
      }
    }

    let from;
    let to;
    if (dateRange && dateRange.length > 0) {
      const [visitStartFrom, visitStartTo] = dateRange;

      from = moment.tz(visitStartFrom.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      }), this.props.timezone || 'utc');
      to = moment.tz(visitStartTo.set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 59,
      }), this.props.timezone || 'utc');

      filterParams[`first_action_timestamp>=${from.toISOString()}`] = null;
      filterParams[`first_action_timestamp<=${to.toISOString()}`] = null;
    }

    return filterParams;
  };

  render() {
    const company = this.props.matomo.leadDetails;
    const { effects } = this.props.loading;
    const { hideLoadMoreButton } = this.state;

    const CardHeader = (props) => {
      return (
        <div className="card-header-inner">
          <div className="card-header-score">
            <ScoringCircle
              publicScore={props.score}
              privateScore={props.private_score}
              finalScore={props.final_score}
              scoringProfile={props.scoring_profile}
              privateScoringProfile={props.private_scoring_profile}
            />
          </div>
          <div className="card-header-date">{props.date.replace(/\s+/g, ' - ')}</div>
        </div>
      );
    };

    return (
      <div>
        <Spin
          spinning={!!effects['leads/getDetails'] || !!effects['matomo/getCompanyVisits']}
          className={styles.companySpinContainer}
        >
          {company && <div className={styles.containerLarge}>
            <LeadDetailsCard projectId={this.projectId} leadId={this.leadId} />
            <Row>
              <Row className="m-0" type="flex" justify="space-between">
                <Col className="card-header mb-20" >
                  <h2><FormattedMessage id="Component.LeadDetails.AllVisits" /></h2>
                </Col>
                <Col xs={24} xl={18}>
                  <CustomizedForm
                    dateFormat={this.props.user.display_datetime_format && this.props.user.display_datetime_format.split(' ')[0]}
                    onChange={this.handleFormChange}
                  />
                </Col>
              </Row>
              <hr className="m-0" />
            </Row>
            <Row gutter={16}>
              {company && this.getModifiedVisits().map(item => (<Col
                className="card-wrap"
                key={item.id}
              >
                <Card
                  style={{ minWidth: '150px', textAlign: 'right' }}
                  className="card card-title-right-no-extra"
                  title={<CardHeader {...item} />}
                  bordered={false}
                >
                  <div className="card-item">
                    <span className="card-item-title"><FormattedMessage id="Component.LeadDetails.Duration" /></span>
                    <span className="card-item-value">{item.durationOfVisit}</span>
                  </div>
                  <div className="card-item">
                    <span className="card-item-title"><FormattedMessage id="Component.LeadDetails.Pages" /></span>
                    <span className="card-item-value">{item.amountOfPages}</span>
                  </div>
                  <div className="card-item">
                    <span className="card-item-title"><FormattedMessage id="Component.LeadDetails.Source" /></span>
                    <span className="card-item-value">{item.source}</span>
                  </div>
                  <div className="card-actions">
                    <Link
                      className="card-link"
                      to={helpers.compileUrl('LEAD_VISITS_VISIT_DETAILS',
                        { projectId: this.projectId, companyId: this.leadId, visitId: item.position })}
                    ><FormattedMessage id="Component.LeadDetails.Details" /></Link>
                  </div>
                </Card>
              </Col>))}
            </Row>
            {hideLoadMoreButton === false && <div>
              <Row type="flex" justify="center">
                <Button
                  type="primary"
                  className="btn-more"
                  onClick={this.fetchCompanyVisits.bind(this)}
                >
                  <FormattedMessage id="Component.LeadDetails.LoadMore" />
                </Button>
              </Row>
              <hr />
            </div>}
          </div>}
        </Spin>
      </div>
    );
  }
}

export default connect(({ loading, leads, app, matomo, leadLabels }) => ({
  loading,
  leads,
  currentProjectId: app.currentProjectId,
  user: app.user,
  matomoProjectId: app.matomoProjectId,
  useCustomBranches: app.useCustomBranches,
  matomo,
  leadLabels,
}))(Form.create()(injectIntl(LeadDetails)));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadDetails/LeadDetails.js